function employeeDataAdapterService($http, dataBrokerService) {
    // TODO: Figure out the best way for this to not be relative. Probably an environment
    // driven solution. The problem here is that /dv is used for local dev. In our test/prod
    // servers we use BigIP to route /dealers traffic to our vertical/dv route.
    const REVIEWS_URL = '/ajax/cics/1.0/dealer/';
    const NUMBER_OF_REVIEWS = 3;
    return {
        REVIEWS_URL,
        fetchEmployees,
        fetchReviews
    };

    function fetchEmployees() {
        return dataBrokerService.getItem('employees');
    }

    function fetchReviews(employee, customerId) {
        return $http({
            method: 'GET',
            url: REVIEWS_URL + customerId + '/reviews/',
            params: {
                employeeId: employee.id,
                includeDealerRaterReviews: true,
                count: NUMBER_OF_REVIEWS
            },
            cache: true
        })
            .then(function(result) {
                return result.data;
            })
            .catch(error => {
                return null;
            });
    }
}

employeeDataAdapterService.$inject = ['$http', 'dataBrokerService'];

export default employeeDataAdapterService;